export default function Menu(){
    return {
        styleOverrides: {
            paper: {
                borderRadius: 8
            }
        }
    }
}